const init = () => {
	let $game = $('.game');
	let $start = $game.find('.game__step--start');
	let $answers = $game.find('.game__step--answers');
	let $btnRestart = $game.find('.game__btn-restart');
	let $btnStart = $game.find('.game__btn--start');
	let $variant = $game.find('.game__rand-variant');
	let $share = $game.find('.share-test--game');
	let $result = $game.find('.game__step--result');
	let timer;
	let view;

	const text = [
		'Lorem Ipsum - это текст-"рыба", часто используемый в печати и вэб-дизайне.',
		'Lorem Ipsum - это текст-"рыба"',
		'ифтов, используя Lorem Ipsum для распечатки образцов. Lorem Ipsum не только успешно пережил без заметных изменений пять веков, но и перешагнул в электронный дизайн. Его популяризации',
		'айн. Его популяризации в новое время послужили публикация листов Letraset с образцами Lorem Ipsum в 60-х годах и, в более недавнее время, программы электронной вёрстки типа Aldus',
		'ри простой дубликации "Здесь ваш текст.. Здесь ваш текст.. Здесь ваш текст.." Многие программы электронной вёрстки и редакторы HTML используют Lorem Ipsum в качестве текста по умолчанию, так что поиск по ключевым словам "lorem ipsum" сразу показ',
	];

	$variant.html(text[0]);

	const reset = () => {
		$answers.removeClass('is-start').addClass('is-result');
		// eslint-disable-next-line no-use-before-define
		pause();
		// eslint-disable-next-line no-use-before-define
		resultView();

		clearTimeout(view);
	};

	const randomize = () => {
		timer = setInterval(() => {
			if (text.length) {
				let index = Math.floor(Math.random() * text.length);
				$variant.html(text[index]);

				$answers.attr('id', index + 1);
			}
		}, 50);

		// eslint-disable-next-line no-use-before-define
		stop();
	};

	const start = () => {
		gsap.timeline()
			.to($start, 0.5, {
				opacity: 0,
				clearProps: true,
			})
			.call(() => {
				$start.addClass('is-hidden');

				$answers.removeClass('is-hidden').addClass('is-start');
				$game.addClass('is-start');

				randomize();
			})
			.from($answers, 0.5, {
				opacity: 0,
				clearProps: true,
			});
	};

	const resultView = () => {
		gsap.timeline()
			.from([$result, $share], 0.5, {
				opacity: 0,
				clearProps: true,
			})
			.call(() => {
				$share.removeClass('is-hidden');
				$result.removeClass('is-hidden');
				$game.addClass('is-end').removeClass('is-start');
				$btnRestart.text('играть еще раз');

				gsap.killTweensOf([$share, $result]);
				gsap.set([$share, $result], {clearProps: 'all'});
			});
	};

	const resultHide = () => {
		gsap.timeline()
			.to([$result, $share], 0.5, {
				opacity: 0,
				clearProps: true,
			})
			.call(() => {
				$share.addClass('is-hidden');
				$result.addClass('is-hidden');
				$game.removeClass('is-end');
				$btnRestart.text('рестарт');
			});
	};

	const stop = () => {
		view = setTimeout(() => {
			// eslint-disable-next-line no-use-before-define
			pause();
			$answers.removeClass('is-start').addClass('is-result');
			resultView();
		}, 5000);
	};

	const pause = () => {
		clearInterval(timer);
	};

	$btnStart.on('click', start);

	$btnRestart.on('click', () => {
		if ($answers.hasClass('is-start')) {
			reset();
		} else {
			resultHide();
			randomize();

			$answers.addClass('is-start').removeClass('is-result');
		}
	});
};

export default {
	init,
};
